export default __webpack_public_path__ + "static/media/uba.34de3801.jpg";